import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import useJwt from '@src/auth/jwt/useJwt'
const config = useJwt.jwtConfig

  const headers = {
    token: localStorage.getItem(config.storageTokenKeyName),
    userID: localStorage.getItem('userID')
  }

  export const addPricing = createAsyncThunk('appPricing/Create', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/Create', params, {mode:'cors'})
    return response
  })

  export const getPricingModelList = createAsyncThunk('appPricing/getTableSummary', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetTableSummary', params)
    return response.data
  })

  export const setPricingModelID = createAsyncThunk('appPricing/setPaymentID', async (id) => {
    return { 
      code: 200,
      PricingModelID:parseInt(id.id)
    }
  })
  export const SaveData = createAsyncThunk('appPricing/SaveData', async (Fixed) => {
     
   const response = await axios.post('https://api.zasway.com:8443/FixedPricing/SaveExcelImportFile', Fixed, { mode: 'cors' })
    
   return response
 })
  export const resetPricingID = createAsyncThunk('appPricing/resetPricingID', async () => {
    return { 
      data: 0
    }
  })

  export const setFixedPricingModelID = createAsyncThunk('appPricing/setFixedPricingModelID', async (id) => {
    return { 
      code: 200,
      FixedPricingModelID:parseInt(id.id)
    }
  })

  export const resetFixedPricingModelID = createAsyncThunk('appPricing/resetFixedPricingModelID', async () => {
    return {
      data: 0
    }
  })

  export const setIsDuplicate = createAsyncThunk('appPricing/setIsDuplicate', async (val) => {
    return { 
      val
    }
  })

  export const updatePricing = createAsyncThunk('appDrvrPayment/Update', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/Update', params, {mode:'cors'})
    return response
  })

  export const updateVehiclePricing = createAsyncThunk('appDrvrPayment/UpdateVehicle', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/UpdateVehicle', params, {mode:'cors'})
    return response
  })

  export const addZonePricing = createAsyncThunk('appPricing/CreateZone', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/CreateZone', params, {mode:'cors'})
    return response
  })

  export const addVehiclePricing = createAsyncThunk('appPricing/CreateVehicle', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/CreateVehicle', params, {mode:'cors'})
    return response
  })

  export const getPreferFrom = createAsyncThunk('appPricing/getPreferFrom', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GePreferFromList')
    return response.data
  })

  export const getMileageStepsMode = createAsyncThunk('appPricing/getMileageStepsMode', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetMileageStepsModeList')
    return response.data
  })

  export const getInheritZone = createAsyncThunk('appPricing/getZoneList', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetZoneList', params, {mode:'cors'})
    return response.data
  })

  export const getBookingStatus = createAsyncThunk('appPricing/getBookingStatusList', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetBookingStatusList')
    return response.data
  })

  export const getBaseToBaseMode = createAsyncThunk('appPricing/getMileageStepsMode', async () => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetMileageStepsModeList')
    return response.data
  })
  
  export const getNationality = createAsyncThunk('appStaff/getNationality', async () => {
    const response = await axios.get('https://api.zasway.com:8443/Common/GetNationalityList', {headers})
    return response.data
  })

  export const getVehicleType = createAsyncThunk('appPricing/getVehicleTypes', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Common/GetVehicleTypes', params, {mode:'cors'})
    return response.data
  })

  export const getAllData = createAsyncThunk('appStaff/GetTableSummary', async (GetStaff) => {
    const response = await axios.post('https://api.zasway.com:8443/Staff/GetTableSummary', GetStaff, {mode:'cors'})
    return response.data
  })

  export const getStaffStats = createAsyncThunk('appStaff/GetStaffStatistics', async (GetStaff) => {
    const response = await axios.post('https://api.zasway.com:8443/Staff/GetStaffStatistics', GetStaff, {mode:'cors'})
    return response.data
  })

  export const getPricingModelLst = createAsyncThunk('appDrvrPayment/GetPricingModels', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetPricingModels', params, {mode:'cors'})
    return {
      params,
      data: response.data
    }
  })

  export const getVehiclePricingModelLst = createAsyncThunk('appDrvrPayment/GetVehiclePricingModel', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetVehiclePricingModel', params, {mode:'cors'})
    return {
      params,
      data: response.data
    }
  })

  export const chkVehiclePricingModelForEdit = createAsyncThunk('appDrvrPayment/chkVehiclePricingModelForEdit', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetVehiclePricingModel', params, {mode:'cors'})
    return  response.data
  })

  export const getPricingMileageStepsList = createAsyncThunk('appPricing/getPricingModelMileageSteps', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetPricingModelMileageSteps', params)
    return response.data
  })

  export const getVehiclePricingModelMileageSteps = createAsyncThunk('appPricing/GetVehiclePricingModelMileageSteps', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetVehiclePricingModelMileageSteps', params)
    return response.data
  })
  export const getVehiclePricingModelMileageStepsBYId = createAsyncThunk('appPricing/getVehiclePricingModelMileageStepsBYId', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetVehiclePricingModelMileageStepsBYID', params)
    return response.data
  })
  
  export const getZonePricingModelMileageSteps = createAsyncThunk('appPricing/GetVehiclePricingModelMileageSteps', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Pricing/getZonePricingModelMileageSteps', params)
    
    return response.data
  })
  export const getPricingModelZoneLst = createAsyncThunk('appDrvrPayment/GetZonePricingModelForEdit', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/GetZonePricingModelForEdit', params, {mode:'cors'})
    return response.data
  })
 
  export const deleteZone = createAsyncThunk('appPricing/DeleteZone', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/DeleteZone', id, {mode:'cors'})
    return response
  })

  export const deletePricingModel = createAsyncThunk('appPricing/Delete', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/Pricing/Delete', id, {mode:'cors'})
    return response
  })

  export const getData = createAsyncThunk('appStaff/getData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Staff/GetTableSummary', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const getStaff = createAsyncThunk('appStaff/getStaff', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Staff/GetTableSummary', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    }
  })

  export const EditStaff = createAsyncThunk('appStaff/Update', async (Staff) => {
    const response = await axios.post('https://api.zasway.com:8443/Staff/Update', Staff, {mode:'cors'})
    return response
  })

  export const deleteStaff = createAsyncThunk('appStaff/Delete', async (id, { dispatch, getState }) => {
    const response = await axios.post('https://api.zasway.com:8443/Staff/Delete', id, {mode:'cors'})
    await dispatch(getData(getState().staff.params))
    return response
  })

  export const getUser = createAsyncThunk('appStaff/getUser', async () => {
    const response = await axios.get('https://api.zasway.com:8443/Vendor/GetVendorList', {headers}, data)
    return response.data
  })

  export const addUser = createAsyncThunk('appStaff/addUser', async (user, { dispatch, getState }) => {
    await axios.post('https://api.zasway.com:8443/User/CreateUser', user, {headers}, {mode:'cors'})
    await dispatch(getData(getState().staff.params))
    await dispatch(getAllData())
    return user
  })

  export const deleteUser = createAsyncThunk('appStaff/deleteUser', async (id, { dispatch, getState }) => {
    await axios.post('https://api.zasway.com:8443/User/DeleteUser', { id }, {headers}, {mode:'cors'})
    await dispatch(getData(getState().staff.params))
    await dispatch(getAllData())
    return id
  })

  export const getStaffImage = createAsyncThunk('appDriver/GetStaffImage', async (Staff) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/GetStaffImage', Staff, {mode:'cors'})
    return response.data
  })

  export const UploadImage = createAsyncThunk('appDriver/UploadImage', async (formData) => {
    const response = await axios.post('https://api.zasway.com:8443/Common/UploadImageStaff', formData, {mode:'cors'})
    return response
  })

  export const getLocationList = createAsyncThunk('appPricing/getLocationList', async (Fixed) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/GetLocationList', Fixed, {mode:'cors'})
     
    return response.data
  })

  export const addFixedPricing = createAsyncThunk('appPricing/addFixedPricing', async (Fixed) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/Create', Fixed, {mode:'cors'})
    return response
  })
  
  export const CheckZoneExistence = createAsyncThunk('appPricing/CheckZoneExistence', async (Fixed) => {
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetZoneID', Fixed, {mode:'cors'})
    return response
  })
  export const editFixedPricing = createAsyncThunk('appPricing/editFixedPricing', async (Fixed) => {
     
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/Update', Fixed, { mode: 'cors' })
     
    return response
  })

  export const getFixedData = createAsyncThunk('appPricing/getFixedData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/GetTableSummary', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total,
      vehicletype: response.data.vehicletype
    } 
  })

  export const getFixedEditData = createAsyncThunk('appPricing/getFixedEditData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/GetTableSummary', params, {mode:'cors'})
    return {
      params,
      data: response.data.data,
      allData: response.data.allData,
      totalPages: response.data.total
    } 
  })

  export const deleteFixedPricing = createAsyncThunk('appPricing/deleteFixedPricing', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/Delete', id, {mode:'cors'})
    return response
  })

  export const deleteAllFixedPricing = createAsyncThunk('appPricing/deleteAllFixedPricing', async (ids) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/DeleteAll', ids, {mode:'cors'})
    return response
  })
  
  export const DeactivateAllFixedPricings = createAsyncThunk('appPricing/DeactivateAllFixedPricings', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/DeactivateAllFixedPricingsByModelID', params, {mode:'cors'})
    return response.data
  })

  export const ImportFixedPricings = createAsyncThunk('appPricing/ImportFixedPricings', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/ImportFixedPricings', params, {mode:'cors'})
    return response.data
  })
  // export const openFixedEditModal = createAsyncThunk('appPricing/openFixedEditModal', async (id) => {
  //   return {data : id}
  // })
  export const getfixedPricingEditData = createAsyncThunk('appPricing/getfixedPricingEditData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/GetTableSummary', params, {mode:'cors'})
    return {data:response.data.data}
  })

  export const getEditData = createAsyncThunk('appPricing/getEditData', async (id) => {
    const response = await axios.post('https://api.zasway.com:8443/FixedPricing/GetEditData', id, { mode: 'cors' })
    return { data: response.data }
  })

  export const getPricingActiveTab = createAsyncThunk('/appPricing/getPricingActiveTab',  (dataParams) => {
     
    return {data : dataParams}
    
  })

export const appPricingSlice = createSlice({
  name: 'appPricing',
  initialState: {
    id: 0,
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    pricingModelID:0,
    PricingModelData: [],
    PricingModelParams: {},
    VehiclePricingModelData: [],
    VehiclePricingModelParams: {},
    fixedPricingEditData: [],
    CurrentTabStatus: null,
    FixedPricingModelID:0,
    Vehicles: [],
    isDuplicate: false
  },
  reducers: {},
  extraReducers: builder => {
    builder

    .addCase(getFixedData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
      state.Vehicles = action.payload.vehicletype
        })

    .addCase(getfixedPricingEditData.fulfilled, (state, action) => {
      state.fixedPricingEditData = action.payload.data
    })

    .addCase(getData.fulfilled, (state, action) => {  
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
    })

    .addCase(getStaff.fulfilled, (state, action) => {
      state.selectedUser = action.payload.allData[0]
    })

    .addCase(addPricing.fulfilled, (state, action) => {
      state.id = action.payload.data.id
      state.pricingModelID = action.payload.data.id
    })

    .addCase(getPricingModelLst.pending, (state) => {
      state.PricingModelData = []
    })
    .addCase(getPricingModelLst.fulfilled, (state, action) => {
      state.PricingModelData = action.payload.data
      state.PricingModelParams = action.payload.params
    })

    .addCase(setPricingModelID.fulfilled, (state, action) => {
      state.pricingModelID = action.payload.PricingModelID
    })

    .addCase(resetPricingID.fulfilled, (state, action) => {
      state.pricingModelID = action.payload.data
      state.PricingModelData = []
      state.PricingModelParams = {}
    })

    .addCase(setFixedPricingModelID.fulfilled, (state, action) => {
      state.FixedPricingModelID = action.payload.FixedPricingModelID
    })

    .addCase(resetFixedPricingModelID.fulfilled, (state) => {
      state.FixedPricingModelID = 0
      state.isDuplicate = false
    })

    .addCase(setIsDuplicate.fulfilled, (state, action) => {
      state.isDuplicate = action.payload.val
    })

    .addCase(getVehiclePricingModelLst.fulfilled, (state, action) => {
      state.VehiclePricingModelData = action.payload.data
      state.VehiclePricingModelParams = action.payload.params
    })
    .addCase(getPricingActiveTab.fulfilled, (state, action) => {
       
      state.CurrentTabStatus = action.payload.data
       
      })  
    // .addCase(openFixedEditModal.fulfilled, (state, action) => {
    //    
    //   state.modal = action.payload.data.ID
    // })
    
  }
})

export default appPricingSlice.reducer